import { render, staticRenderFns } from "./ShortcutHelp.vue?vue&type=template&id=48b910f6&scoped=true"
import script from "./ShortcutHelp.vue?vue&type=script&lang=ts"
export * from "./ShortcutHelp.vue?vue&type=script&lang=ts"
import style0 from "./ShortcutHelp.vue?vue&type=style&index=0&id=48b910f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b910f6",
  null
  
)

export default component.exports